import { REQUEST_ACTIVITY_STRINGS } from "./strings/request-activity";
import { WORKFLOW_STRINGS } from "./strings/workflow";
import { DIALOGUE_LAB_STRINGS } from "./strings/reqventos-dialogue-lab";
// Operator-console UI dictionary. Feature dictionaries stay structurally DE/EN paired
// and are composed here so callers keep one stable import and lookup surface.
import { ADMIN_STRINGS } from "./strings/admin";
import { CORE_STRINGS } from "./strings/core";
import type { Dictionary } from "./strings/dictionary";
import { OVERVIEW_DEMO_STRINGS } from "./strings/overview-demo";
import { STATUS_STRINGS } from "./strings/status";
import { WORKSPACE_STRINGS } from "./strings/workspace";
import { SINGLE_LAB_STRINGS } from "./strings/reqventos-single-lab";
import { AGENT_LAB_STRINGS } from "./strings/reqventos-agent-rules-lab";
import { EMAIL_QA_STRINGS } from "./strings/email-qa";

export type Lang = "de" | "en";

export const DICT: Dictionary = {
  ...REQUEST_ACTIVITY_STRINGS,
  ...WORKFLOW_STRINGS,
  ...CORE_STRINGS,
  ...WORKSPACE_STRINGS,
  ...STATUS_STRINGS,
  ...ADMIN_STRINGS,
  ...OVERVIEW_DEMO_STRINGS,
  ...EMAIL_QA_STRINGS,
  ...AGENT_LAB_STRINGS,
  ...SINGLE_LAB_STRINGS,
  ...DIALOGUE_LAB_STRINGS,
};
